reviewed-your-spot<template>
    <div class="notifications-list">

        <h2 v-if="notifications.length <= 0" class="empty-state">No Notifications</h2>

        <div v-for="(notification, index) in notifications"
             class="notifications-list__single"
             :class="{ 'new' : notification.status != 'read'}"
             v-show="notification.status != 'hidden'">

            <!-- User From -->
            <a v-if="notification.user_from" :href="`/${notification.user_from.username}`" class="avatar">
                <img :src="notification.user_from.md_avatar">
            </a>

            <!-- When no User -->
            <a href="#" v-else class="avatar">
                <span style="background: #E5C89A; display: block; width: 31px; height: 31px; border-radius: 50%; padding: 5px;">
                    <svg style="width: 21px; height: 21px;" class="icon-star"><use xlink:href="#icon-star"></use></svg>
                </span>
            </a>

            <!-- New Message -->
            <div v-if="notification.type == 'messaged'"
                 @click="view(notification,'/messages?conversation='+notification.user_from.username)">
                <span class="name" v-text="notification.user_from.full_name"></span>
                sent you a <span>Message</span>
                <span class="time" v-text="diffForHumans(notification.created_at)"></span>
            </div>

            <!-- Commented Review -->
            <div v-if="notification.type == 'commented-review'"
                 @click="view(notification,'/'+notification.recommendation.city.slug+'/'+notification.recommendation.slug)">
                <span class="name" v-text="notification.user_from.full_name"></span>
                commented on your <span>Review</span> of <span>{{notification.recommendation.title}}</span>
                <span class="time" v-text="diffForHumans(notification.created_at)"></span>
            </div>

            <!-- Liked a Review -->
            <div v-if="notification.type == 'liked-review'"
                 @click="view(notification,'/'+notification.recommendation.city.slug+'/'+notification.recommendation.slug)">
                <span class="name" v-text="notification.user_from.full_name"></span>
                liked your <span>Review</span> of <span>{{notification.recommendation.title}}</span>
                <span class="time" v-text="diffForHumans(notification.created_at)"></span>
            </div>

            <!-- Followed You -->
            <div v-if="notification.type == 'followed-you'"
                 @click="view(notification,'/'+notification.user_from.username)">
                <span class="name" v-text="notification.user_from.full_name"></span>
                followed you
                <span class="time" v-text="diffForHumans(notification.created_at)"></span>
            </div>

            <div v-if="notification.type == 'followed-list'"
                 @click="view(notification,'/'+notification.user.username+'/list/'+notification.list.slug)">
                <span class="name" v-text="notification.user_from.full_name"></span>
                followed your list <span>{{notification.list.name}}</span>
                <span class="time" v-text="diffForHumans(notification.created_at)"></span>
            </div>

            <!-- Reviewed Your Spot -->
            <div v-if="notification.type == 'reviewed-your-spot'"
                 @click="view(notification,'/'+ notification.recommendation.city.slug + '/'+ notification.recommendation.slug)">
                <span class="name" v-text="notification.user_from.full_name"></span>
                reviewed your spot <span>{{notification.recommendation.title}}</span>
                <span class="time" v-text="diffForHumans(notification.created_at)"></span>
            </div>

            <!-- Referral Joined -->
            <div v-if="notification.type == 'referral-joined'" @click="view(notification,'/'+notification.user_from.username)">
                Your friend
                <span class="name" v-text="notification.user_from.full_name"></span>
                joined the club
                <span class="time" v-text="diffForHumans(notification.created_at)"></span>
            </div>

            <!-- Spot Added to a List -->
            <div v-if="notification.type == 'added-to-list'"
                 @click="view(notification,'/'+notification.user_from.username+'/list/'+notification.list.slug)">
                <span class="name" v-text="notification.user_from.full_name"></span>
                added
                <span v-text="notification.recommendation.title"></span>
                to their list
                <span v-text="notification.list.name"></span>
                <span class="time" v-text="diffForHumans(notification.created_at)"></span>
            </div>

            <!-- Updated Caption List -->
            <div v-if="notification.type == 'updated-caption-list'"
                 @click="view(notification, `/${notification.user_from.username}/list/${notification.list.slug}`)">
                <span class="name" v-text="notification.user_from.full_name"></span>
                updated the caption for
                <span v-text="notification.recommendation.title"></span>
                on their list
                <span v-text="notification.list.name"></span>
                <span class="time" v-text="diffForHumans(notification.created_at)"></span>
            </div>

            <!-- Saved your Spot -->
            <div v-if="notification.type == 'saved-your-spot'"
                 @click="view(notification, `/${notification.user_from.username}/list/${notification.list.slug}`)">
                <span class="name" v-text="notification.user_from.full_name"></span>
                just saved
                <span v-text="notification.recommendation.title"></span>
                to their list
                <span v-text="notification.list.name"></span>
                <span class="time" v-text="diffForHumans(notification.created_at)"></span>
            </div>

            <!-- New Comment On your Post -->
            <div v-if="notification.type == 'new-comment-on-your-post'" @click="redirectTo(notification.payload.url)">
                <span class="name" v-text="notification.user_from.full_name"></span>
               commented on your journal <span v-text="notification.payload.post"></span>
                <span class="time" v-text="diffForHumans(notification.created_at)"></span>
            </div>

            <!-- New Post Published -->
            <div v-if="notification.type == 'new-post-published'" @click="redirectTo(notification.payload.url)">
                <span class="name" v-text="notification.user_from.full_name"></span>
                just published a new journal you might like: <span v-text="notification.payload.post"></span>
                <span class="time" v-text="diffForHumans(notification.created_at)"></span>
            </div>

            <!-- New Post Published to Author -->
            <div v-if="notification.type == 'new-post-published-to-author'" @click="redirectTo(notification.payload.url)">
                Good news! Your journal post <span v-text="notification.payload.post"></span> is now live! 🎉
                <span class="time" v-text="diffForHumans(notification.created_at)"></span>
            </div>

            <!-- New Response On your Comment Thread -->
            <div v-if="notification.type == 'new-response-on-your-comment-thread'" @click="redirectTo(notification.payload.url)">
                <span class="name" v-text="notification.user_from.full_name"></span>
                responded to your thread on <span v-text="notification.payload.post"></span>
                <span class="time" v-text="diffForHumans(notification.created_at)"></span>
            </div>

            <!-- Duplicated List -->
            <div v-if="notification.type == 'duplicated-list'" @click="redirectTo(notification.payload.url)">
                Members are loving your lists! <span style="font-style: normal">😍</span>
                <span class="name" v-text="notification.user_from.full_name"></span>
                just duplicated your list
                <span v-text="notification.list.name"></span>
                <span class="time" v-text="diffForHumans(notification.created_at)"></span>
            </div>

            <!-- General Interest -->
            <GeneralInterest
                v-model="notifications[index]"
                :key="notification.id"
                v-if="['journal-page', 'list-page', 'destination-page', 'spot-page', 'marketing'].includes(notification.type)">
            </GeneralInterest>

            <button class='notifications-list__single__close'
                    @click="setHidden(notification)"><svg class='close'><use xlink:href="#close"></use></svg>
            </button>

        </div>
    </div>
</template>

<script>
import GeneralInterest from './GeneralInterest'
/*
* messaged
* commented-review
* liked-review
* followed-you
* followed-list
* reviewed-your-spot
* referral-joined
* added-to-list
* deleted-from-list
* updated-caption-list
 */

import Helpers from '@/mixins/Helpers'

export default {

    mixins: [Helpers],

    components: {
        GeneralInterest
    },

    props: ['user', 'inotificationcount'],

    data() {
        return {
            notifications: [],
        }
    },

    mounted() {

        this.getNotifications();

        eventBus.$on('showNotifications', (index) => {
            axios.get('/notifications/shown')
                .then((response) => {

                });

            var new_counter = this.inotificationcount;
            if (new_counter > 0) {
                $('.header-notifications-trigger__badge span').html(new_counter);
            }
        })
    },

    methods: {

        getNotifications() {
            axios.get('/notifications')
                .then((response) => {
                    this.notifications = response.data.notifications;

                    // var new_counter = 0;
                    // this.notifications.forEach((notification, index) => {
                    //     if (notification.status == 'new')
                    //         new_counter++;
                    // });

                    let totalNewNotifications = this.inotificationcount + response.data.news_count;

                    if (totalNewNotifications > 0) {
                        $('.header-notifications-trigger__badge').show();
                        $('.header-notifications-trigger__badge span').html(totalNewNotifications);
                    }
                });
        },

        view(notification, redirect) {
            console.log(notification)
            axios.post('/notification/read/' + notification.id, {notification: notification})
                .then((response) => {
                    if (redirect) {
                        window.location.href = redirect;
                    }
                });
        },


        setHidden(notification) {

            axios.post('/notification/hide/' + notification.id, {notification: notification})
                .then((response) => {
                    notification.status = 'hidden';
                });
        },

        show() {

        }

    }
}
</script>
